/* eslint-disable */
import React from "react";
import CodeBlock from "./CodeBlock";

export default {
  pre: ({ children }) => <CodeBlock>{children}</CodeBlock>,
};
